import noop from 'lodash/noop';
import { useState } from 'react';

import Button from '../Button/Button';
import { TrashIcon } from '../Icon/Icon';
import { DropdownBodyStyled, DropdownHeaderStyled, DropdownWrapStyled } from './Dropdown.styled';

export type DropdownPropsT = {
  children: React.ReactNode;
  label: React.ReactElement;
  isOpen?: boolean;
  isClickable?: boolean;
  isArrowVisible?: boolean;
  isDeleteHide?: boolean;
  onDelete?: () => void;
};

const Dropdown: React.FC<DropdownPropsT> = ({
  label,
  children,
  isOpen = false,
  isClickable = true,
  isArrowVisible = true,
  isDeleteHide,
  onDelete,
}) => {
  const [isVisible, setVisibility] = useState(isOpen);

  return (
    <DropdownWrapStyled>
      <DropdownHeaderStyled
        isOpen={isVisible}
        isArrowVisible={isClickable && isArrowVisible}
        onClick={isClickable ? () => setVisibility(!isVisible) : noop}
      >
        {label}
      </DropdownHeaderStyled>

      {isVisible && (
        <DropdownBodyStyled>
          {children}

          {!isDeleteHide && (
            <Button modifier="inline" onClick={onDelete}>
              <TrashIcon />
            </Button>
          )}
        </DropdownBodyStyled>
      )}
    </DropdownWrapStyled>
  );
};

export default Dropdown;
